/**
 * @fileoverview Application Entry Point
 * @description Main entry point for the XtreamTranscoder frontend application
 * @module @xtream/frontend/main
 *
 * OWNERSHIP: This file is owned by FASE 12 (Dev13)
 *
 * This file:
 * - Imports global styles
 * - Sets up React StrictMode
 * - Mounts the App component to the DOM
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Global styles
import '@styles/index.css';

// ═══════════════════════════════════════════════════════════════════════════
// ROOT ELEMENT
// ═══════════════════════════════════════════════════════════════════════════

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Make sure there is a div with id="root" in index.html');
}

// ═══════════════════════════════════════════════════════════════════════════
// RENDER APPLICATION
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Mount the React application
 * StrictMode helps identify side effects and deprecated patterns
 */
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// ═══════════════════════════════════════════════════════════════════════════
// DEV MODE LOGGING
// ═══════════════════════════════════════════════════════════════════════════

if (import.meta.env.DEV) {
  /* eslint-disable no-console */
  console.log(
    '%c🎬 XtreamTranscoder Frontend',
    'color: #0ea5e9; font-size: 16px; font-weight: bold;',
  );
  console.log('%cDevelopment mode - FASE 12 (WebSocket + Routing) configurado', 'color: #22c55e;');
  /* eslint-enable no-console */
}
